import { Check, Copy } from 'lucide-react';
import { useState, type ReactNode } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

function CodeBlock({ className, children }: { className?: string; children?: ReactNode }) {
  const [copied, setCopied] = useState(false);
  const value = String(children).replace(/\n$/, '');
  const language = className?.replace('language-', '') || 'kode';

  return (
    <div className="code-block">
      <div className="flex h-9 items-center justify-between border-b border-border px-3 text-xs text-muted">
        <span className="font-mono">{language}</span>
        <button
          type="button"
          className="interactive flex items-center gap-1.5 hover:text-primary"
          onClick={async () => {
            await navigator.clipboard.writeText(value);
            setCopied(true);
            window.setTimeout(() => setCopied(false), 1400);
          }}
        >
          {copied ? <Check className="size-3.5" /> : <Copy className="size-3.5" />}
          {copied ? 'Tersalin' : 'Salin kode'}
        </button>
      </div>
      <pre><code>{value}</code></pre>
    </div>
  );
}

export function MarkdownContent({ value }: { value: string }) {
  return (
    <div className="markdown-content">
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          a: ({ children, ...props }) => <a {...props} target="_blank" rel="noreferrer">{children}</a>,
          pre: ({ children }) => <>{children}</>,
          code: ({ className, children, ...props }) => {
            const block = Boolean(className) || String(children).includes('\n');
            return block ? <CodeBlock className={className}>{children}</CodeBlock> : <code {...props}>{children}</code>;
          },
        }}
      >
        {value}
      </ReactMarkdown>
    </div>
  );
}
